module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('span', {
    staticClass: "border"
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I would like to thank the following people, who helped me complete this project: Bruce Beesley, Jenni Roman, Dr. Paul Bloom, James Loewen, Adam Clark, and Marita (Bach) Pinkstaff. I also need to thank Melissa Richards and Marc Favreau of The New Press for their extraordinary assistance in putting this project together.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And a very special thanks to Dr. David Vancil and Dennis Vetrovec at the Indiana State University Library (ISU) Special Collections Department. These two men and their department were invaluable to my research, to say the least. The ISU Special Collections Department currently houses thirteen major collections, two of which have international importance: the Eugene V. Debs Collection and the Cordell Collection of Dictionaries. Other collections have a more regional or national focus, such as the Cunningham, the Floyd Family, and the Walker collections. The Cunningham Collection contains early or significant works in American education on practice and theory, while the Floyd Family and Walker collections contain over twenty-five hundred cataloged textbooks. While these collections cover all subject areas, the largest number of books are in the fields of history and English."), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6af4a40e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Ack.vue
// module id = 72
// module chunks = 0